module.exports = __webpack_public_path__ + "img/zimg8.ed69ab4f.png";